/*
 * @Author: Czy 1162306744@qq.com
 * @Date: 2026-03-02 15:48:17
 * @LastEditors: Czy 1162306744@qq.com
 * @LastEditTime: 2026-03-09 18:08:53
 * @FilePath: /ayh-mobile-overseas/src/main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createSSRApp } from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './i18n'
import { routeInterceptor, requestInterceptor, prototypeInterceptor } from './interceptors'
import 'virtual:uno.css'
import '@/style/index.scss'
// import { install, version } from '@ued/atomic/lib'

export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  app.use(i18n)

  // wot-design-uni 的语言初始化已移到 App.vue 的 initializeI18nLanguage() 中处理
  // 这样可以确保在 store 持久化数据恢复后再设置语言

  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  return {
    app,
  }
}
